import { createSelector } from '@reduxjs/toolkit';

export const adminSelector = createSelector(
    (state: ReturnType<any>) => state.admin,
    (state) => state,
);
